export const TRANSLATION_PREFIX = 'STATIC.PAGES.MANUAL_UPLOAD';

export const MIXPANEL_PREFIX = 'Manual Upload';

export const ACCEPTED_FILE_TYPES = ['.csv', '.xls', '.xlsx', '.zip', '.gz'];

export const DEFAULT_TEXT_FIELDS = [
    { key: 'country', param: 'country', label: `${TRANSLATION_PREFIX}.DEFAULT_COUNTRY` },
    { key: 'campaign', param: 'campaign', label: `${TRANSLATION_PREFIX}.DEFAULT_CAMPAIGN` },
];

// `param` is the query-string key the endpoint expects, suffixed with `_h` where it would collide
// with the same-named default value.
const headerField = (key, param, name) => ({
    key,
    param,
    label: `${TRANSLATION_PREFIX}.HEADER_${name}`,
    placeholder: `${TRANSLATION_PREFIX}.HEADER_${name}_PLACEHOLDER`,
});

export const HEADER_FIELDS = [
    headerField('date', 'date', 'DATE'),
    headerField('campaign', 'campaign_h', 'CAMPAIGN'),
    headerField('campaignid', 'campaignid', 'CAMPAIGN_ID'),
    headerField('adnetwork', 'adnetwork_h', 'ADNETWORK'),
    headerField('sub_adnetwork', 'sub_adnetwork_h', 'SUB_ADNETWORK'),
    headerField('platform', 'platform_h', 'PLATFORM'),
    headerField('cost', 'cost', 'COST'),
    headerField('installs', 'installs', 'INSTALLS'),
    headerField('clicks', 'clicks', 'CLICKS'),
    headerField('impressions', 'impressions', 'IMPRESSIONS'),
];

export const INSTRUCTION_KEYS = [
    `${TRANSLATION_PREFIX}.INSTRUCTIONS_HEADERS`,
    `${TRANSLATION_PREFIX}.INSTRUCTIONS_MANDATORY`,
    `${TRANSLATION_PREFIX}.INSTRUCTIONS_OPTIONAL`,
    `${TRANSLATION_PREFIX}.INSTRUCTIONS_DEFAULTS`,
    `${TRANSLATION_PREFIX}.INSTRUCTIONS_DATA_SOURCES`,
];
